import { render, staticRenderFns } from "./menuSub.vue?vue&type=template&id=10d7a3c4&"
import script from "./menuSub.vue?vue&type=script&lang=js&"
export * from "./menuSub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports